// extracted by mini-css-extract-plugin
export default {"content":"ProfileList_content__9W6hj","triangle":"ProfileList_triangle__fuz7n","square":"ProfileList_square__M3IWi","item":"ProfileList_item__jMAdk"};